// Auto-generated rank list mirrors backend: 5 base tiers × 5 divisions + 3 master ranks
const BASES = [
  { tier: "Đồng", english: "Bronze", color: "#fb923c", bg: "from-orange-500/20 to-orange-700/5", border: "border-orange-400/40", text: "text-orange-300" },
  { tier: "Bạc", english: "Silver", color: "#cbd5e1", bg: "from-slate-300/20 to-slate-500/5", border: "border-slate-300/40", text: "text-slate-200" },
  { tier: "Vàng", english: "Gold", color: "#facc15", bg: "from-yellow-400/25 to-yellow-700/5", border: "border-yellow-400/40", text: "text-yellow-300" },
  { tier: "Bạch Kim", english: "Platinum", color: "#2dd4bf", bg: "from-teal-400/25 to-teal-700/5", border: "border-teal-400/40", text: "text-teal-200" },
  { tier: "Kim Cương", english: "Diamond", color: "#38bdf8", bg: "from-sky-400/25 to-sky-700/5", border: "border-sky-400/40", text: "text-sky-200" },
];
const ROMAN = ["V", "IV", "III", "II", "I"];

const tiers = [];
let p = 0;
for (const b of BASES) {
  for (const div of ROMAN) {
    tiers.push({ name: `${b.tier} ${div}`, tier: b.tier, division: div, min: p, max: p + 99, color: b.color, english: b.english, bg: b.bg, border: b.border, text: b.text });
    p += 100;
  }
}
tiers.push({ name: "Cao Thủ", tier: "Cao Thủ", division: null, min: p, max: p + 499, color: "#c084fc", english: "Master", bg: "from-purple-500/25 to-purple-800/5", border: "border-purple-400/40", text: "text-purple-200" });
p += 500;
tiers.push({ name: "Đại Cao Thủ", tier: "Đại Cao Thủ", division: null, min: p, max: p + 499, color: "#f59e0b", english: "Grandmaster", bg: "from-amber-500/30 to-orange-700/10", border: "border-amber-400/60", text: "text-amber-300" });
p += 500;
tiers.push({ name: "Thách Đấu", tier: "Thách Đấu", division: null, min: p, max: 99999, color: "#ef4444", english: "Challenger", bg: "from-red-500/30 to-rose-700/10", border: "border-red-500/60", text: "text-red-300" });

export const RANKS = tiers;

export const getRank = (rp = 0) => {
  for (const r of RANKS) if (rp >= r.min && rp <= r.max) return r;
  return RANKS[0];
};

export const nextRank = (rp = 0) => {
  const cur = getRank(rp);
  const idx = RANKS.findIndex((r) => r.name === cur.name);
  return RANKS[idx + 1] || cur;
};

export const progressToNext = (rp = 0) => {
  const cur = getRank(rp);
  if (cur.name === "Thách Đấu") return 100;
  const span = cur.max - cur.min;
  return Math.min(100, Math.round(((rp - cur.min) / span) * 100));
};
